import { useMutation } from "urql";

import { HandoverLimitRequestToCuManagerDocument } from "../../../graphql/generated.ts";

export const useHandoverLimitRequestToCUManager = () =>
  useMutation(HandoverLimitRequestToCuManagerDocument);
